/* PrimeStyle: custom design lead tracking + delivery (2026-10-12)
   -------------------------------------------------------------------------
   Shared by every custom page (the hub, the category pages, design-customize).
   Loaded before ps-cust26-form.js / ps-cust26-send.js / ps-cust26-hub.js.

   Why it exists: until today no custom request reached any ad platform.
   The senders dropped the query string, so UTMs, fbclid and gclid were lost;
   the done screen appeared 800 ms after SEND whatever the transport did; and
   nothing told Meta, GA4, Google Ads or Bing that a lead happened
   (Digital Marketing brief, owner "send the fix" 2026-10-12).

   What it does:
   1. Captures attribution on landing: first touch in localStorage (30 days),
      last touch in sessionStorage.
   2. Mints the request ids: ref (PS-C-...) and event_id (ref + 4 chars). The
      engine keeps both in the draft, so a reload-and-resend reuses them.
   3. deliver(): posts to the mailer and READS its {ok} (the /exec answer is
      readable cross-origin, checked 2026-10-12), falls back to Shopify's
      contact form, and reports failure honestly. No upload listeners on
      purpose: they force a CORS preflight that Apps Script cannot answer.
   4. lead(): fires Meta Lead (with eventID) and pushes generate_lead +
      ps_custom_lead to the dataLayer, once per ref, only on a confirmed send.
      GTM owns the Google and Bing side; there is no direct gtag call, or
      every lead would count twice.

   No name, email or phone ever goes into an ad event. */
(function () {
  'use strict';
  if (window.PSCustLead) return;

  var FT_KEY = 'ps-cust:ft', LT_KEY = 'ps-cust:lt';
  var POSTED_KEY = 'ps-cust:posted', LEAD_KEY = 'ps-cust:lead:';
  var FT_DAYS = 30;
  var PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id',
    'fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid'];

  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function read(s, k) { try { var v = s && s.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; } }
  function write(s, k, v) { try { if (s) s.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function drop(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }
  var LS = store('localStorage'), SS = store('sessionStorage');

  /* ---- 1. attribution, captured on landing ---- */
  (function capture() {
    var q;
    try { q = new URLSearchParams(location.search); } catch (e) { return; }
    var touch = {}, paid = false;
    PARAMS.forEach(function (k) {
      var v = q.get(k);
      if (v) { touch[k] = String(v).slice(0, 300); paid = true; }
    });
    touch.landing_url = String(location.href).slice(0, 1000);
    touch.referrer = String(document.referrer || '').slice(0, 500);
    touch.landed_at = new Date().toISOString();
    /* A page view without campaign parameters (the contact form's return trip,
       a click between custom pages) never overwrites the touch that brought
       the shopper here. */
    if (paid || !read(SS, LT_KEY)) write(SS, LT_KEY, touch);
    var ft = read(LS, FT_KEY);
    if (!ft || !ft.exp || ft.exp < Date.now()) write(LS, FT_KEY, { exp: Date.now() + FT_DAYS * 864e5, touch: touch });
  })();

  function touches() {
    return { lt: read(SS, LT_KEY) || {}, ft: (read(LS, FT_KEY) || {}).touch || {} };
  }

  function klaviyoProps() {
    var t = touches(), o = {};
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'msclkid']
      .forEach(function (k) { o[k] = t.lt[k] || ''; });
    o.landing_url = t.lt.landing_url || '';
    o.ft_utm_source = t.ft.utm_source || '';
    o.ft_utm_content = t.ft.utm_content || '';
    return o;
  }

  function describe(t) {
    var utm = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term']
      .map(function (k) { return t[k] || '-'; });
    if (utm.join('') !== '-----') return utm.join(' / ');
    if (t.gclid || t.gbraid || t.wbraid) return 'Google Ads click (no UTMs)';
    if (t.fbclid) return 'Meta click (no UTMs)';
    if (t.msclkid) return 'Microsoft Ads click (no UTMs)';
    if (t.referrer) {
      try { return 'Referral from ' + new URL(t.referrer).hostname; } catch (e) { return 'Referral'; }
    }
    return t.landing_url ? 'Direct or unknown' : 'Not recorded';
  }

  /* The store-only block. The mailer echoes `body` into the shopper's own
     confirmation, so attribution travels in its own `internal` field and the
     mailer renders it in the store email only. */
  function internalBlock(eventId) {
    var t = touches(), lt = t.lt, ft = t.ft, lines = ['AD ATTRIBUTION (store only)'];
    if (eventId) lines.push('Lead event id: ' + eventId);
    lines.push('Last touch: ' + describe(lt));
    var clicks = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'msclkid'].filter(function (k) { return lt[k]; })
      .map(function (k) { return k + '=' + lt[k]; });
    if (clicks.length) lines.push('Click ids: ' + clicks.join(', '));
    if (lt.landing_url) lines.push('Landing page: ' + lt.landing_url);
    if (lt.referrer) lines.push('Referrer: ' + lt.referrer);
    lines.push('First touch: ' + describe(ft) + (ft.landed_at ? ' (' + String(ft.landed_at).slice(0, 10) + ')' : ''));
    return lines.join('\n');
  }

  /* ---- 2. request ids ---- */
  function newIds() {
    var ref = 'PS-C-' + Date.now().toString(36).toUpperCase().slice(-6);
    var abc = '0123456789abcdefghijklmnopqrstuvwxyz', tail = '';
    for (var i = 0; i < 4; i++) tail += abc.charAt(Math.floor(Math.random() * 36));
    return { ref: ref, eventId: ref + '.' + tail };
  }

  /* ---- 4. the lead, once per ref, only on a confirmed send ---- */
  function lead(info) {
    if (!info || !info.ref) return false;
    if (SS && SS.getItem(LEAD_KEY + info.ref)) return false;
    try { if (SS) SS.setItem(LEAD_KEY + info.ref, String(Date.now())); } catch (e) {}
    var eid = info.eventId || info.ref;
    var common = {
      lead_ref: info.ref,
      piece_type: info.pieceType || '',
      budget_range: info.budget || '',
      timeline: info.timeline || '',
      form: info.form || '',
      delivery_route: info.route || ''
    };
    var dl = window.dataLayer = window.dataLayer || [];
    dl.push(Object.assign({ event: 'generate_lead' }, common));
    dl.push(Object.assign({ event: 'ps_custom_lead', event_id: eid, transaction_id: eid }, common));
    /* GTM loads the Meta pixel after first paint. On the contact form's return
       trip this can run first, so wait for fbq rather than lose the Lead. */
    var tries = 0;
    (function fire() {
      if (typeof window.fbq === 'function') {
        try {
          window.fbq('track', 'Lead', {
            content_name: 'Custom Design Request',
            content_category: info.pieceType || '',
            form: info.form || ''
          }, { eventID: eid });
        } catch (e) {}
        return;
      }
      if (++tries < 60) setTimeout(fire, 250);
    })();
    return true;
  }

  /* ---- 3. delivery ---- */
  function submitForm(form) {
    var send = function () {
      if (typeof form.requestSubmit === 'function') { form.requestSubmit(); return; }
      var b = document.createElement('button');
      b.type = 'submit'; b.style.display = 'none';
      form.appendChild(b); b.click(); b.remove();
    };
    /* Shopify's storefront captcha binds on the submit EVENT and posts the
       token itself; a background fetch is refused with 403 (2026-09-18). */
    if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound) { send(); return; }
    try { form.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    var waited = 0, t = setInterval(function () {
      waited += 250;
      if (form.dataset.hcaptchaBound || form.dataset.recaptchaBound || waited >= 3000) { clearInterval(t); send(); }
    }, 250);
  }

  function captchaOpen() {
    var frames = document.querySelectorAll('iframe[src*="hcaptcha"], iframe[src*="recaptcha"]');
    for (var i = 0; i < frames.length; i++) {
      var r = frames[i].getBoundingClientRect();
      if (r.width > 100 && r.height > 100) return true;
    }
    return false;
  }

  /* opts: { endpoint, params (URLSearchParams), form, fill(form), posted, onRouted(route) }
     Resolves { ok, route } with route = endpoint | endpoint_unconfirmed | failed.
     The contact-form route is a page navigation: it never resolves, and the
     returning page reports the lead through restorePosted(). */
  function deliver(o) {
    return new Promise(function (resolve) {
      var settled = false;
      function finish(res) { if (!settled) { settled = true; resolve(res); } }

      function fallback() {
        if (!o.form || navigator.onLine === false) { finish({ ok: false, route: 'failed' }); return; }
        try { o.fill(o.form); } catch (e) { finish({ ok: false, route: 'failed' }); return; }
        write(SS, POSTED_KEY, o.posted || {});
        /* onRouted may ask for extra time (the Klaviyo event, see trackDelay) */
        var extra = 0;
        try { if (o.onRouted) extra = +o.onRouted('contact_form') || 0; } catch (e) {}
        /* a moment for klaviyo.js to flush the event before the page leaves */
        setTimeout(function () {
          try { submitForm(o.form); } catch (e) { drop(SS, POSTED_KEY); finish({ ok: false, route: 'failed' }); }
        }, 300 + Math.min(extra, 3000));
        /* Still here long after the submit? The post never left: say so. Not
           while Shopify's captcha puzzle is open, though: a shopper solving it
           is mid-send, and an error behind it would invite a second request
           (QA 2026-10-12: headless Chrome gets the puzzle). */
        var waited = 0;
        (function watch() {
          setTimeout(function () {
            if (settled) return;
            waited += 30000;
            if (captchaOpen() && waited < 600000) { watch(); return; }
            drop(SS, POSTED_KEY);
            finish({ ok: false, route: 'failed' });
          }, 30000);
        })();
      }

      if (!o.endpoint) { fallback(); return; }
      var body = o.params.toString();
      var ctl = typeof AbortController === 'function' ? new AbortController() : null;
      /* No progress events without a preflight, so the limit scales with the
         payload: 30 s plus 10 s per MB, at most 3 minutes. */
      var limit = Math.min(180000, 30000 + Math.ceil(body.length / 1048576) * 10000);
      var timer = ctl ? setTimeout(function () { ctl.abort(); }, limit) : null;
      var init = {
        method: 'POST', mode: 'cors', credentials: 'omit',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: body
      };
      /* keepalive caps the body at 64KB in Chrome (2026-09-23): small bodies only */
      if (body.length < 60000) init.keepalive = true;
      if (ctl) init.signal = ctl.signal;
      fetch(o.endpoint, init).then(function (r) {
        if (timer) clearTimeout(timer);
        if (r.type === 'opaque') { finish({ ok: true, route: 'endpoint_unconfirmed' }); return; }
        return r.text().then(function (txt) {
          var j = null;
          try { j = JSON.parse(txt); } catch (e) {}
          /* {ok:false} = the mailer threw; anything not JSON = an error or
             sign-in page. Neither carried the request. */
          if (r.ok && j && j.ok === true) finish({ ok: true, route: 'endpoint' });
          else fallback();
        });
      })['catch'](function () {
        if (timer) clearTimeout(timer);
        fallback();
      });
    });
  }

  /* On the page Shopify sends back after the contact form: report the lead
     once and hand back what the done screen needs. */
  function restorePosted() {
    var posted = read(SS, POSTED_KEY);
    drop(SS, POSTED_KEY);
    if (!posted || !posted.ref) return null;
    if (posted.draftKey) drop(LS, posted.draftKey);
    lead({
      ref: posted.ref, eventId: posted.eventId, pieceType: posted.pieceType,
      budget: posted.budget, timeline: posted.timeline, form: posted.form, route: 'contact_form'
    });
    return posted;
  }

  /* what the page calls this form in every event */
  function formId() {
    var seg = String(location.pathname).split('/').filter(Boolean).pop() || 'custom';
    return seg.replace(/[^a-z0-9-]/gi, '').toLowerCase();
  }

  /* hub-engagement -> engagement; design-<slug> -> design */
  function pieceType(category) {
    var c = String(category || '');
    if (c.indexOf('hub-') === 0) return c.slice(4);
    if (c.indexOf('design-') === 0) return 'design';
    return c || 'jewelry';
  }

  function timeline(st) {
    st = st || {};
    if (st.date) return 'by ' + st.date;
    return st.occasion || '';
  }

  /* Klaviyo drops a track pushed in the same moment as its identify (QA
     2026-10-12: Klaviyo's API showed the event only when the two were seconds
     apart). Callers note the identify time and wait this long before track. */
  var identifiedAt = 0;
  function identified() { identifiedAt = Date.now(); }
  function trackDelay() { return identifiedAt ? Math.max(0, 2000 - (Date.now() - identifiedAt)) : 0; }

  window.PSCustLead = {
    identified: identified,
    trackDelay: trackDelay,
    klaviyoProps: klaviyoProps,
    internalBlock: internalBlock,
    newIds: newIds,
    deliver: deliver,
    lead: lead,
    restorePosted: restorePosted,
    formId: formId,
    pieceType: pieceType,
    timeline: timeline
  };
})();
